/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file

==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// GPS location
import './location.js'

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// WebRTC adapter
import 'webrtc-adapter'

// Globally Registered Components
import './globalComponents.js'

// Notify Prototypes
import './layouts/notifies'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vazir font
import '@/assets/css/vazir.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'
Vue.prototype.$filters = Vue.options.filters

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// socket.io
import io from './socket.js'
Vue.prototype.$io = io()

// Clipboard
// import VueClipboard from 'vue-clipboard2'
// Vue.use(VueClipboard)

// Tour
// import VueTour from 'vue-tour'
// Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from 'vee-validate'
import englishValidationMessages from 'vee-validate/dist/locale/en'
import persianValidationMessages from 'vee-validate/dist/locale/fa'
import arabicValidationMessages from 'vee-validate/dist/locale/ar'
import './validators'
Vue.use(VeeValidate, {
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    en: englishValidationMessages,
    fa: persianValidationMessages,
    ar: arabicValidationMessages
  }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

//Vue Jalali Moment
import moment from 'jalali-moment'
Vue.prototype.$moment = moment

Vue.config.productionTip = false

import { version } from '../package.json'
Vue.prototype.$version = version

const app = new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
})

const iceServers = [
  {
    "urls": "stun:turn.30teb.app:3478",
    "username": "cteb",
    "credential": "WV3TIfXM8oTKfwFbpng9flCE"
  },
  {
    "urls": "turn:turn.30teb.app:3478",
    "username": "cteb",
    "credential": "WV3TIfXM8oTKfwFbpng9flCE"
  }
]

window.localConnection = new RTCPeerConnection({ iceServers })

// Push Notification
import worker from './plugins/worker'
Vue.use(worker)
import './registerServiceWorker'

export default app

if (localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo')) {
  Promise.all([store.dispatch('config/fetchGeneralConfigs'), store.dispatch('enum/fetchGeneralEnums')]).then(
    () => {
      app.$mount('#app')
      // let cats = store.state.config.placeCategorySubject
      // let services = store.getters['config/provinceServiceDetails']
      // let res = {}
      // // console.log(services)
      // Object.entries(cats).forEach(([key, value]) => {
      //   // console.log(key, '+++++++++++++++++++++++++++++++++++')
      //   if (!res[key]) res[key] = { _: i18n.t(`places.categories.${key}`) }
      //   value.forEach(item => {
      //     // console.log(item, '------------------')
      //     if (!res[key][item]) res[key][item] = { _: i18n.t(`places.subjects.${item}`) }
      //     if (services[item])
      //       Object.keys(services[item]).forEach(k => {
      //         // console.log(k)
      //         res[key][item][k] = i18n.t(`health_services.${item}.${k}`)
      //       })
      //   })
      // })
      // console.log(res)
      // console.log(JSON.stringify(res))
    }
  )
} else {
  app.$mount('#app')
}
